export default {"src":"/_next/static/image/src/images/banner-fullwidth-grey.ad337109faa60f9eac9c5ac33db055a7.svg","height":399,"width":270};